<template>
  <div>
    <Summary />
  </div>
</template>

<script>
import Summary from '@/nfmp_components/Summary.vue'
export default {
  components: {
    Summary
  }
}
</script>